import '@doss/guest-frame/boot-splash.css'
import { bootWordmarkSvg } from '@doss/guest-frame/boot-splash-markup'
import { Stack } from '@mui/material'
import { useId } from 'react'
import { useTypedTranslation } from '~/common/hooks/useTypedTranslation'
import {
  DOSS_WORDMARK_LETTER_PATHS,
  DOSS_WORDMARK_VIEW_BOX,
} from '~/components/navigation/wordmark-paths'

/** Full-page app loading screen: the wordmark whose glyph IS the boot spinner. Unanchored —
 * app-level loading has no handoff to preserve — so it opens on the hero (static-wordmark)
 * pose and animates from there. */
export const LoadingScreen = () => {
  const { t } = useTypedTranslation()
  return (
    <Stack
      alignItems="center"
      aria-busy="true"
      aria-label={t('common.actions.loading')}
      dangerouslySetInnerHTML={{
        __html: bootWordmarkSvg(useId(), {
          viewBox: DOSS_WORDMARK_VIEW_BOX,
          letterPaths: DOSS_WORDMARK_LETTER_PATHS,
        }),
      }}
      justifyContent="center"
      role="status"
      sx={{ height: '100vh' }}
    />
  )
}
